import { render, staticRenderFns } from "./IbCommissionInTabTable.vue?vue&type=template&id=0f7783eb"
import script from "./IbCommissionInTabTable.vue?vue&type=script&lang=js"
export * from "./IbCommissionInTabTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports